import * as React from 'react'
import {Dialog, DialogDismiss, DialogHeading} from '@ariakit/react'
import * as dialogStyles from '@frontrow/console/src/components/dialog/dialog.module.scss'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {faPencilAlt} from '@fortawesome/free-solid-svg-icons'
import {Button} from '@frontrow/console/src/components/button'

// Components
import SchoolAdminForm from '@frontrow/console/src/components/pages/school-admins-page/school-admin-form'

// Models
import {
  type DetailedSchoolAdminT,
  type SchoolAdminUpdateT
} from '@frontrow/console/src/models/school-admin'
import {useModalForm} from '@frontrow/console/src/hooks/use-modal-form'

type Props = {
  updateSchoolAdmin: (schoolAdminId: number, updateSchoolAdminData: SchoolAdminUpdateT) => void
  schoolAdminToUpdate: DetailedSchoolAdminT
}

function SchoolsAdminFormButtonModal(props: Props): React.ReactElement {
  const {updateSchoolAdmin, schoolAdminToUpdate} = props
  const {isOpen, open, close} = useModalForm()

  const updateSchoolAdminHandler = (updatedSchoolAdminData: SchoolAdminUpdateT) => {
    updateSchoolAdmin(schoolAdminToUpdate.id, updatedSchoolAdminData)
    close()
  }

  return (
    <React.Fragment>
      <Button style="link" title="Update School Admin" onClick={open}>
        <FontAwesomeIcon icon={faPencilAlt} size="lg" />
      </Button>
      <Dialog
        open={isOpen}
        onClose={close}
        backdrop={<div className={dialogStyles.backdrop} />}
        className={dialogStyles.dialog}
        portal
        unmountOnHide
        hideOnEscape
        hideOnInteractOutside={false}
      >
        <div className={dialogStyles.header}>
          <DialogHeading className={dialogStyles.title}>
            Update {`${schoolAdminToUpdate.firstName} ${schoolAdminToUpdate.lastName}`}
          </DialogHeading>
          <DialogDismiss className={dialogStyles.closeButton}>
            <span aria-hidden="true">&times;</span>
          </DialogDismiss>
        </div>
        <div className={dialogStyles.body}>
          <SchoolAdminForm
            schoolAdminToUpdate={schoolAdminToUpdate}
            onSubmit={updateSchoolAdminHandler}
            onCancel={close}
          />
        </div>
      </Dialog>
    </React.Fragment>
  )
}

export default SchoolsAdminFormButtonModal
